<div class="instructionForSupplierModal-container">
  <div class="instructionForSupplierModal-header">
    <span class="instructionForSupplierModal-headerText">{{
      'HAVE_QUESTIONS_ABOUT_THE_SYSTEM_DOWNLOAD' | translate
    }}</span>
    <mat-icon mat-dialog-close>close</mat-icon>
  </div>

  <div class="instructionForSupplierModal-content">
    <div
      class="instructionForSupplierModal-instruction"
      (click)="downloadPdf()">
      <div class="instructionForSupplierModal-instructionFile">
        <img src="assets/svg/docx.svg" alt="Docx" />
        <span> {{ 'INSTRUCTION_FOR_THE_SUPPLIER' | translate }}</span>
      </div>

      <img src="assets/svg/download.svg" alt="Download" />
    </div>
  </div>

  <div class="instructionForSupplierModal-info">
    <span class="instructionForSupplierModal-infoTitle">
      {{
        'IF_YOU_STILL_HAVE_QUESTIONS, PLEASE_CONTACT_OUR_TECHNICAL_SUPPORT_TEAM'
          | translate
      }}:</span
    >

    <div class="instructionForSupplierModal-infoContacts">
      <img src="assets/svg/phones.svg" alt="Phone" width="24" height="24" />
      <span>+38 080 033 7506</span>
    </div>
    <div class="instructionForSupplierModal-infoContacts">
      <img src="assets/svg/mail.svg" alt="Mail" width="24" height="24" />
      <span>{{ 'support@neolink.co' }}</span>
    </div>
  </div>
</div>
